const global_data = {
  local_username: "",
}
export { global_data };